import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getPendingPayments = (params: any = {}) => {
  const snakeParams = camelToSnake(params);
  return api.get(`${BASE_URL}/api/v1/pending-payments`, { params: snakeParams });
};
